import React from 'react';
import { useTranslation } from 'react-i18next';

import scss from './UploadedBy.module.scss';

function UploadedBy({ name, username }) {
  const { t } = useTranslation('activ8');

  if (!name && !username) {
    return null;
  }

  return (
    <div className={scss.wrapper}>
      <span className={scss.label}>{t('uploadedBy')}:</span>
      {name ? <span className={scss.fullName}>{name}</span> : null}
      {username ? <span className={scss.username}>{username}</span> : null}
    </div>
  );
}

export default UploadedBy;
